import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { of, Subscription } from 'rxjs';
import { ConfigService } from 'src/config/config.service';
import { Router } from '@angular/router';
import { autenticar } from 'src/app/models/SicarMap/Inicio/autenticar.model';
import { AppState } from 'src/app/store/app.reducer';
import { LogIn, ExecRegistro } from 'src/app/store/actions';
import { AuthService } from 'src/app/services/SicarMap/auth.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { resetPassword } from '../../../models/SicarMap/Inicio/resetPassword.model';
import { Forgot } from '../../../store/actions/login/resetPassword.actions';
import { catchError, map } from 'rxjs/operators';
import { alertMessage } from '../../../models/SicarMap/Inicio/alertMessage.model';

@Component({
  selector: 'app-flogin',
  templateUrl: './flogin.component.html',
  styleUrls: ['./flogin.component.css']
})
export class FloginComponent implements OnInit, OnDestroy {
  MultiSesion = true;
  submitted = false;
  loading = false;
  dropdownEnabled = false; // Nueva propiedad para controlar el estado del dropdown
  passwordVisible = false; // Propiedad para controlar la visibilidad de la contraseña

  ExisteError = false;
  ErrorUsuario = false;
  ErrorForgotUsuario = false;
  ErrorConrasena = false;
  ErrorPerfil = false;
  PanelForgotPassword = false;

  Usuario = '';
  ForgotUsuario = '';
  Contrasena = '';
  PerfilS = -1;
  alert: alertMessage;

  error: any;

  perfiles: any[] = [];
  usuarioDisable = false;
  constrasenaDisable = true;
  OpcionesInicio = false;
  BbtnValidar = false;

  loginSubcripcion: Subscription = new Subscription();
  RegistroSubcripcion: Subscription = new Subscription();

  constructor(
    private store: Store<AppState>,
    private config: ConfigService,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.loginSubcripcion = this.store.select('auth').subscribe((data: any) => {
      if (data.cuenta) {
        if (data.cuenta.perfiles.length > 1) {
          (document.getElementById('usuario') as HTMLInputElement).disabled = true;
          (document.getElementById('contrasena') as HTMLInputElement).disabled = true;
          this.OpcionesInicio = true;
          this.loading = false;
          this.PanelForgotPassword = false;
          this.perfiles = []
          this.error = '';
          data.cuenta.perfiles.forEach((ItemP) => {
            this.perfiles.push({
              id: ItemP.pidperfil,
              perfil: ItemP.snombre
            });
          });
        } else {
          if (data.cuenta.perfiles.length === 0) {
            this.ExisteError = true;
            this.PanelForgotPassword = false;
            this.error = 'El usuario no contiene perfil';
            this.loading = false;
          } else {
            this.PanelForgotPassword = false;
            this.loading = false;
            this.error = '';
            this.store.dispatch(new ExecRegistro(new autenticar(this.Usuario, this.Contrasena, data.cuenta.perfiles[0].pidperfil)));
          }
        }
      } else if (data.errorMessage) {
        this.ExisteError = true;
        if (data.errorMessage.status === 0) {
          this.error = 'No existe conexion con el servicio';
        } else if (data.errorMessage.status === 401 && data.errorMessage.error !== null) {
          this.error = data.errorMessage.error.message;
        } else {
          if (data.errorMessage.error !== null) {
            this.error = data.errorMessage.error.message;
          } else {
            this.ExisteError = false;
          }
        }
        this.loading = false;
        this.PanelForgotPassword = false;
      } else {
        this.loading = false;
        this.PanelForgotPassword = false;
      }
    });
    this.RegistroSubcripcion = this.store.select('rRegUsr').subscribe((data: any) => {
      if (data.TokenActive) {
        const perfilesG = this.authService.Usuario.perfiles.find((Item) => Item.pidperfil === data.TokenActive.perfilActivo);
        if (perfilesG) {
          if (perfilesG.badministrador) {
            this.router.navigate(['/home/Adm']);
          } else if(perfilesG.breportes) {
            this.router.navigate(['/home/reports']);
          }else{
            this.router.navigate(['/home/Map']);
          }
        }
      } else if (data.errorMessage) {
        this.OpcionesInicio = false;
        (document.getElementById('usuario') as HTMLInputElement).disabled = false;
        (document.getElementById('contrasena') as HTMLInputElement).disabled = false;
        this.ExisteError = true;
        if (data.errorMessage.status === 0) {
          this.error = 'No existe conexion con el servicio';
        } else if (data.errorMessage.status === 401 && data.errorMessage.error !== null) {
          this.error = data.errorMessage.error.message;
        } else {
          if (data.errorMessage.error !== null) {
            this.error = data.errorMessage.error.message;
          } else {
            this.ExisteError = false;
          }
        }
        this.loading = false;
        this.PanelForgotPassword = false;
      } else {
        this.loading = false;
        this.PanelForgotPassword = false;
      }
    });
    this.alert = new alertMessage(
      null,
      false,
      null,
      null,
      null,
    );
    this.BbtnValidar = false;
  }

  ngOnDestroy() {
    if (this.loginSubcripcion) {
      this.loginSubcripcion.unsubscribe();
    }
    if (this.RegistroSubcripcion) {
      this.RegistroSubcripcion.unsubscribe();
    }
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  Ingresar() {
    this.loading = true;
    if (this.validar()) {
      this.store.dispatch(new LogIn(new autenticar(this.Usuario, this.Contrasena)));
    } else {
      this.loading = false;
    }
  }

  async ResetPassword() {
    this.loading = true;
    this.alert = new alertMessage(
      null,
      false,
      null,
      null,
      null,
    );
    if (this.validarForgot()) {
      this.authService.sendEmail(this.ForgotUsuario).subscribe(response => {
        this.loading = false;
        if (response['item1'] === true ){
          this.alert.alertClass = 'success';
          this.alert.alertShow = true;
          this.alert.alertHeader = 'Se ha enviado un correo para recuperar tu contraseña.'
          this.alert.alertMessage = null;
          this.alert.alertDetails = 'si no aparece en la bandeja de entrada consulte la carpeta de spam';
        } else {
          this.loading = false;
          this.alert.alertClass = 'danger';
          this.alert.alertShow = true;
          this.alert.alertHeader = response['item2'];
          this.alert.alertMessage = null;
          this.alert.alertDetails = 'verifique que su informacion este actualizada';
        }
      }, error => {
        console.error('Error al enviar correo:', error);
      });
    }
  }

  validarForgot() {
    let numeroErrores = 0;
    if (this.ForgotUsuario === '') {
      numeroErrores++;
      this.ErrorForgotUsuario = true;
    } else {
      this.ErrorForgotUsuario = false;
    }
    if (numeroErrores === 0) {
      return true;
    } else {
      return false;
    }
  }

  validar() {
    let numeroErrores = 0;
    if (this.Usuario === '') {
      numeroErrores++;
      this.ErrorUsuario = true;
    } else {
      this.ErrorUsuario = false;
    }
    if (this.Contrasena === '' || this.Contrasena.length < 6) {
      numeroErrores++;
      this.ErrorConrasena = true;
    } else {
      this.ErrorConrasena = false;
    }
    if (this.OpcionesInicio) {
      if (this.PerfilS === -1) {
        numeroErrores++;
        this.ErrorPerfil = true;
      } else {
        this.ErrorPerfil = false;
      }
    }
    if (numeroErrores === 0) {
      return true;
    } else {
      return false;
    }
  }

  RegistrarPerfil() {
    this.loading = true;
    if (this.validar()) {
      (document.getElementById('usuario') as HTMLInputElement).disabled = false;
      (document.getElementById('contrasena') as HTMLInputElement).disabled = false;
      this.store.dispatch(new ExecRegistro(new autenticar(this.Usuario, this.Contrasena, this.PerfilS)));
      this.perfiles = [];
      this.PerfilS = -1;
      this.OpcionesInicio = false;
      this.loading = false;
    } else {
      this.loading = false;
    }
  }

  showPanelForgotPassword(e) {
    this.BbtnValidar = false;
    this.ForgotUsuario = '';
    this.PanelForgotPassword = Boolean(e);
    this.alert = new alertMessage(
      null,
      false,
      null,
      null,
      null,
    );
  }
}
